/** Manual ВР scale (ENG-T14 groups 1…5). */
export const MANUAL_EXTERNAL_RATINGS = [100, 90, 80, 70, 60];
export const MANUAL_EXTERNAL_RATING_OPTIONS = MANUAL_EXTERNAL_RATINGS.map((value) => ({
    value: String(value),
    label: String(value),
}));
export function parseManualExternalRating(raw) {
    const value = Number(raw);
    return MANUAL_EXTERNAL_RATINGS.includes(value)
        ? value
        : null;
}
